__turbopack_context__.v({
  "quoteLayoutWrapper": "QuoteLayout-module-scss-module__A6XigG__quoteLayoutWrapper",
});
